import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { DropdownMenu } from '../DropdownMenu/DropdownMenu';
import { ReactComponent as ChevronDown } from '../../pages/SearchPage/assets/chevron-down.svg';
import { EmbeddingContext, WindmillApp } from '../../pages/WindmillAppPage/types';
import { EmbeddedAppRunModal } from './EmbeddedAppRunModal';
import { useEmbeddedWindmillApps } from './useEmbeddedWindmillApps';

interface CaseWindmillAppsMenuProps {
  caseId: number;
}

/** Case page header dropdown listing the windmill apps embedded in cases. */
export const CaseWindmillAppsMenu: React.FC<CaseWindmillAppsMenuProps> = ({
  caseId,
}) => {
  const { t } = useTranslation();
  const apps = useEmbeddedWindmillApps('case');
  const [isOpen, setIsOpen] = useState(false);
  const [activeApp, setActiveApp] = useState<WindmillApp | null>(null);
  const embedding = useMemo<EmbeddingContext>(
    () => ({ mode: 'case', case_id: caseId }),
    [caseId],
  );

  if (apps.length === 0) return null;

  return (
    <>
      <DropdownMenu
        isOpen={isOpen}
        header={t('Apps')}
        onClick={() => setIsOpen(!isOpen)}
        buttonName={t('Apps')}
        icon={<ChevronDown />}
        menuClassName="export"
        frontIcon={null}
        disabled={false}
      >
        <ul>
          {apps.map((app) => (
            <li
              key={app.id}
              className="new-li"
              onClick={() => {
                setIsOpen(false);
                setActiveApp(app);
              }}
            >
              {app.icon ? `${app.icon} ` : ''}
              {app.name}
            </li>
          ))}
        </ul>
      </DropdownMenu>
      {activeApp && (
        <EmbeddedAppRunModal
          key={activeApp.id}
          app={activeApp}
          embedding={embedding}
          onClose={() => setActiveApp(null)}
        />
      )}
    </>
  );
};
